import { fetchEncryptGet } from '#providers/Fetch';
import makeHandler from '#services/makeHandler';

const URL = {
  getAll: 'company',
};

const getAll = makeHandler(async (query = {}) => fetchEncryptGet(URL.getAll, query),
  { defaultError: 'Error fetching companies' });

export default {
  getAll,
};
